import styled from "styled-components";
export const Styles = styled.div`
.buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    position: absolute;
    width: 100%;
    height: 10vh;
    bottom: 0;
    left: 0;
    border-top: 1px solid var(--dark-purple);
    padding-top: 10px;
    z-index: 100;
    background-color: #fff;
    box-shadow: 0px 2px 10px var(--dark-purple) !important;
  }
  .btn-container.danger .btn{
    filter: brightness(0.7);
    /* background: var(--red-lighter) !important;
    border-color: var(--red-lighter) !important; */
  }
  .btn-container.danger .btn:hover{
    color: var(--dark-purple) !important;
  }
  .raise-hand{
    padding: 5px;
  }
  .raise-hand .stop {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
  }
  .raise-hand .stop::after {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    width: 1.5px;
    height: 120%;
    border-radius: 50px;
    background: #fff;
    transform: translate(-50%, -50%) rotate(130deg);
  }
  .raise-hand .btn:hover .stop::after {
    background: #6f2877;
  }
`;